export default __webpack_public_path__ + "static/media/risk-collapse-active.91d82d96.svg";